// extracted by mini-css-extract-plugin
export default {"root":"StoryInfoDrawer-root-a713ea81c575376ddcd310f53bc3fc79"};